import React, { LabelHTMLAttributes } from 'react'
import clsx from 'clsx'

import { IconStar, IconQuestionMarkCircle } from '../Icons'

export interface FormControlProps
  extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean
  label?: string
  className?: string
  recommend?: string
  tooltip?: string
}

const FormControl: React.FC<FormControlProps> = (
  props: FormControlProps,
): JSX.Element => {
  const {
    required = false,
    htmlFor,
    label,
    className,
    children,
    recommend,
    tooltip,
  } = props
  const base = 'form-control'

  const locationTooltip = htmlFor === 'branch location' && tooltip && (
    <div className={`${base}__tooltip`}>
      <IconQuestionMarkCircle />
      <span className={`${base}__tooltip-text`} data-testid='tooltip-text'>
        {tooltip}
      </span>
    </div>
  )

  const title = required ? (
    <div className={`${base}__title`}>
      {label?.toString().replace(':', '')}
      <IconStar
        className={`${base}__required`}
        data-testid={`${base}-required`}
      />
      <span>:</span>
    </div>
  ) : (
    label
  )

  return (
    <div className={clsx(base, className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className={`${base}__label`}
          data-testid={`${base}-label`}
        >
          {title}
          {locationTooltip}
          {recommend && (
            <span className={`${base}__recommend`}>{recommend}</span>
          )}
        </label>
      )}
      {children}
    </div>
  )
}

export default FormControl
